// Block focus
// -----------------------------------------------------------------------------

export type BlockId = string;

export type FormAutomationFocusStateData =
  | {
      panel: "automation" | "automation-new";
    }
  | {
      panel: "automation-edit-blockAction";
      blockActionIndex: number;
    }
  | {
      panel: "automation-edit-zap";
      zapId: string;
    };

export type FormFocusStateData =
  | {
      panel: "fields" | "data" | "new-field";
    }
  | FormAutomationFocusStateData;

export type FieldFocusStateData = { panel: "field" | "logic" };

export type FilterFocusStateData =
  | { panel: "filter"; filterId: number }
  | { panel: "filter-new" };

export type TableFocusStateData =
  | { panel: "setup" | "data" }
  | FilterFocusStateData;

export type MediaFocusStateData = { panel: "setup" };

export type ButtonFocusStateData =
  | { panel: "setup" | "actions" }
  | { panel: "actions-edit"; blockActionIndex?: number };

export type ChecklistFocusStateData =
  | {
      panel: "content" | "data" | "automation" | "automation-new";
    }
  | {
      panel: "automation-edit-zap";
      zapId: string;
    }
  | FilterFocusStateData;

export type StripePaymentActionsFocusStateData =
  | {
      panel: "stripe-actions" | "stripe-actions-new";
    }
  | {
      panel: "stripe-actions-edit-blockAction";
      blockActionIndex: number;
    }
  | {
      panel: "stripe-actions-edit-zap";
      zapId: string;
    };

export type StripePaymentFocusStateData =
  | StripePaymentActionsFocusStateData
  | {
      panel: "content";
    };

export type FocusStateData =
  | FormFocusStateData
  | FieldFocusStateData
  | TableFocusStateData
  | MediaFocusStateData
  | ButtonFocusStateData
  | ChecklistFocusStateData
  | StripePaymentFocusStateData;

export type BlockFocus = {
  blockId: BlockId;
  data?: FocusStateData;
};

export type FormFocusState = {
  blockId: BlockId;
  data: FormFocusStateData;
};

// Combined focus types
// -----------------------------------------------------------------------------

export type FocusState = BlockFocus | null;

export type SetFocusState = (focusState: FocusState) => void;

// Utilities
// -----------------------------------------------------------------------------

export function blockIsFocused(
  focusState: FocusState | undefined
): focusState is BlockFocus {
  return !!focusState;
}

export function assertBlockIsFocused(
  focusState: FocusState | undefined
): asserts focusState is BlockFocus {
  if (!blockIsFocused(focusState))
    throw new Error("focusState is not BlockFocus");
}
